import { configureStore } from "@reduxjs/toolkit";
import accountReducer from "../account/accountSlice";
import forgotPasswordReducer from "../account/forgotPasswordSlice";
import resetPasswordReducer from "../account/resetPasswordSlice";
import loginReducer from "../account/loginSlice";
import startRegistrationReducer from "../account/startRegistrationSlice";
import confirmRegistrationReducer from "../account/confirmRegistrationSlice";
import confirmInviteRegistrationReducer from "../account/confirmInviteRegistrationSlice";
import adminUsersReducer from "../admin/adminUsersSlice";
import adminCustomersReducer from "../admin/adminCustomersSlice";
import adminLeadsReducer from "../admin/adminLeadsSlice";
import adminProductsReducer from "../admin/adminProductsSlice";
import adminInventoryReducer from "../admin/adminStockItemsSlice";
import adminOffersReducer from "../admin/adminOffersSlice";
import adminRfqsReducer from "../admin/adminRfqsSlice";
import adminMachinesReducer from "../admin/adminMachinesSlice";
import customerSearchAndBuyReducer from "../customer/searchAndBuy/customerSearchAndBuySlice";
import customerBuyerInventoryReducer from "../customer/searchAndBuy/customerBuyerInventorySlice";
import customerProductSuppliersReducer from "../customer/productSuppliers/customerProductSuppliersSlice";
import customerMyRfqsReducer from "../customer/myRfqs/customerMyRfqsSlice";
import customerReceivedOffersReducer from "../customer/offersReceived/customerReceivedOffersSilce"
import customerRfqFeedReducer from "../customer/rfqFeed/customerRfqFeedSlice";
import customerInventoryReducer from "../customer/inventory/customerInventorySlice";
import customerSentOffersReducer from "../customer/sentOffers/customerSentOffersSlice";
import customerCompaniesReducer from "../customer/companies/customerCompaniesSlice";
import customerCompanyGroupsReducer from "../customer/companyGroups/customerCompanyGroupsSlice";
import customerMachineryReducer from "../customer/machinery/customerMachinerySlice";
import customerMachineReducer from "../customer/machinery/customerMachineSlice";
import machineCatalogReducer from "../customer/machinery/machineCatalogSlice";
import customerMachineStatsReducer from "../customer/machinery/customerMachineStatsSlice";
import customerInternalStockReducer from "../customer/machinery/customerInternalStockSlice";
import customerSettingsReducer from "../customer/settings/customerSettingsSlice";
import customerContactsReducer from "../customer/settings/customerContactsSlice";
import customerShippingOptionsReducer from "../customer/settings/customerShippingOptionsSlice";
import customerServiceReportsReducer from "../customer/machinery/customerMachineServiceReportsSlice";
import customerMachineDocumentsReducer from "../customer/machinery/customerMachineDocumentsSlice";
import customerUsersReducer from "../customer/settings/customerUsersSlice";
import customerAccountReducer from "../customer/settings/customerAccountSlice";
import customerServicingReducer from "../customer/servicing/customerServicingSlice";
import customerServiceBoardReducer from "../customer/serviceBoard/customerServiceBoardSlice";
import customerOffersReducer from "../customer/serviceOffers/customerOffersSlice";
import customerServiceReceivedOffersReducer from "../customer/servicing/receivedOffersSlice";
import notificationsReducer from "../shared/notifications/notificationsSlice";
import notificationPreferencesReducer from "../shared/notifications/notificationPreferencesSlice";
import notificationHistoryReducer from "../shared/notifications/notificationHistorySlice";
import customerPartnershipsReducer from "../customer/partnerships/customerPartnershipsSlice";
import serviceProviderPricingReducer from "../customer/settings/serviceProviderPricingSlice";
import serviceExecutionReducer from "../customer/servicing/serviceExecutionSlice";
import serviceReviewsReducer from "../customer/servicing/serviceReviewsSlice";
import publicReducer from "../public/publicSlice";
import accessDeniedReducer from "../public/accessDeniedSlice";
import chatBotReducer from "../shared/chatBot/chatBotSlice";
import machineGroupsReducer from "../customer/machinery/machineGroupsSlice";
import customerLocationsReducer from "../customer/machinery/customerLocationsSlice";
import trackingReducer from "../shared/tracking/trackingSlice";
import midasPageReducer from "../customer/midas/midasPageSlice";
import midasMessageFeedbackV2Reducer from "../customer/midas/components/v2/midasMessageFeedbackV2Slice";
import workOrdersReducer from "../customer/operations/store/workOrdersSlice";
import serviceReportsPageReducer from "../customer/operations/store/serviceReportsSlice";

export const store = configureStore({
  reducer: {
    account: accountReducer,
    forgotPassword: forgotPasswordReducer,
    resetPassword: resetPasswordReducer,
    login: loginReducer,
    startRegistration: startRegistrationReducer,
    confirmRegistration: confirmRegistrationReducer,
    confirmInviteRegistration: confirmInviteRegistrationReducer,
    adminUsers: adminUsersReducer,
    adminCustomers: adminCustomersReducer,
    adminLeads: adminLeadsReducer,
    adminProducts: adminProductsReducer,
    adminInventory: adminInventoryReducer,
    adminOffers: adminOffersReducer,
    adminRfqs: adminRfqsReducer,
    adminMachines: adminMachinesReducer,
    customerSearchAndBuy: customerSearchAndBuyReducer,
    customerProductSuppliers: customerProductSuppliersReducer,
    customerBuyerInventory: customerBuyerInventoryReducer,
    customerMyRfqs: customerMyRfqsReducer,
    customerReceivedOffers: customerReceivedOffersReducer,
    customerRfqFeed: customerRfqFeedReducer,
    customerInventory: customerInventoryReducer,
    customerSentOffers: customerSentOffersReducer,
    customerCompanies: customerCompaniesReducer,
    customerCompanyGroups: customerCompanyGroupsReducer,
    customerMachinery: customerMachineryReducer,
    customerMachine: customerMachineReducer,
    machineCatalog: machineCatalogReducer,
    customerMachineStats: customerMachineStatsReducer,
    customerInternalStock: customerInternalStockReducer,
    customerSettings: customerSettingsReducer,
    customerAccount: customerAccountReducer,
    customerContacts: customerContactsReducer,
    customerShippingOptions: customerShippingOptionsReducer,
    customerUsers: customerUsersReducer,
    customerServiceReports: customerServiceReportsReducer,
    customerMachineDocuments: customerMachineDocumentsReducer,
    customerServicing: customerServicingReducer,
    customerServiceBoard: customerServiceBoardReducer,
    customerOffers: customerOffersReducer,
    customerServiceReceivedOffers: customerServiceReceivedOffersReducer,
    customerPartnerships: customerPartnershipsReducer,
    serviceExecution: serviceExecutionReducer,
    serviceReviews: serviceReviewsReducer,
    notifications: notificationsReducer,
    notificationPreferences: notificationPreferencesReducer,
    notificationHistory: notificationHistoryReducer,
    serviceProviderPricing: serviceProviderPricingReducer,
    public: publicReducer,
    accessDenied: accessDeniedReducer,
    chatBot: chatBotReducer,
    machineGroups: machineGroupsReducer,
    customerLocations: customerLocationsReducer,
    tracking: trackingReducer,
    midasPage: midasPageReducer,
    midasMessageFeedbackV2: midasMessageFeedbackV2Reducer,
    workOrders: workOrdersReducer,
    serviceReportsPage: serviceReportsPageReducer,
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
